window.theme = window.theme || {};

theme.Collection = (function () {
  function Collection() {
    // The banner is a separate section, so it is outside the collection container.
    this.$collectionImage = $('.collection-hero__image');
    if (!this.$collectionImage.length) return;

    this.$collectionImage.addClass('is-init');
    if (!theme.supports3DTransforms()) return;

    this.$window = $(window);
    this.onScroll = function () {
      this.$collectionImage.css({
        transform: 'translate3d(0, ' + this.$window.scrollTop() / 4.5 + 'px, 0)'
      });
    }.bind(this);
    this.$window.on('scroll', this.onScroll);
  }

  Collection.prototype.onUnload = function () {
    if (this.onScroll) this.$window.off('scroll', this.onScroll);
  };

  return Collection;
})();
